<div class="container notes-history-page">
  <div class="page-header screen-only">
    <div class="patient-identity">
      <div class="patient-avatar" aria-hidden="true">{{ patientInitials }}</div>
      <div class="patient-heading">
        <p class="eyebrow">Notes History</p>
        <h1 class="patient-name">{{ patent_name || 'Patient' }}</h1>
      </div>
    </div>
    <div class="header-actions">
      <button type="button" class="btn btn-brand" (click)="exportPdf()" [disabled]="items.length === 0">
        Export PDF
      </button>
    </div>
  </div>

  <div class="card details-card screen-only">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span>Clinician Notes</span>
      <span class="count-badge">{{ items.length }}</span>
    </div>
    <div class="card-body p-0">
      @if (items.length === 0) {
        <div class="empty-state">
          <p class="empty-title">No notes yet</p>
          <p class="empty-text">Clinician notes for this patient will appear here.</p>
        </div>
      } @else {
        @for (item of pagedItems; track item; let i = $index) {
          <article class="note-block">
            <div class="note-header">
              <div class="note-title-row">
                <span class="note-index">{{ ((page - 1) * pageSize) + i + 1 }}</span>
                <h2 class="note-title">{{ item?.title || 'Note' }}</h2>
              </div>
              <div class="note-dates">
                <span>Created {{ item?.created_at | date: 'dd MMM yyyy' }}</span>
                <span>Updated {{ item?.updated_at | date: 'dd MMM yyyy' }}</span>
              </div>
            </div>
            <p class="note-meta">Seen by {{ getDoctor(item?.doctor_id) || '—' }}</p>
            <p class="note-body">{{ item?.description }}</p>
          </article>
        }
      }
    </div>
    @if (items.length > pageSize) {
      <div class="table-footer">
        <ngb-pagination [collectionSize]="items.length" [(page)]="page" [pageSize]="pageSize"
          [maxSize]="5" [rotate]="true" [ellipses]="false" [boundaryLinks]="false">
        </ngb-pagination>
      </div>
    }
  </div>

  <section class="print-sheet" aria-hidden="true">
    <header class="print-header">
      <img src="assets/images/physioLife logo artwork-02.png" alt="Physio Life">
      <div>
        <p class="print-clinic">PHYSIO LIFE CLINIC</p>
        <h1>Notes History</h1>
      </div>
    </header>

    <div class="print-summary">
      <div>
        <span>Patient</span>
        <strong>{{ patent_name || 'Patient' }}</strong>
      </div>
      <div>
        <span>Notes</span>
        <strong>{{ items.length }}</strong>
      </div>
      <div>
        <span>Printed</span>
        <strong>{{ today | date: 'dd MMM yyyy' }}</strong>
      </div>
    </div>

    @for (item of items; track item; let i = $index) {
      <article class="print-note">
        <div class="print-note-top">
          <strong>{{ i + 1 }}. {{ item?.title || 'Note' }}</strong>
          <span>{{ item?.created_at | date: 'dd MMM yyyy' }}</span>
        </div>
        <p class="print-meta">
          Seen by {{ getDoctor(item?.doctor_id) || '—' }}
          · Updated {{ item?.updated_at | date: 'dd MMM yyyy' }}
        </p>
        <p class="print-body">{{ item?.description }}</p>
      </article>
    }
  </section>
</div>
